import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigationHook } from '../../Hooks/NavigationHook';
import './styles.css';

const PetAssureNationTable = () => {
  const { currentStep, formsConfig } = useNavigationHook();
  const { insuredInfo, process } = useSelector((storeState) => storeState);
  // Local state to track pets and force re-render
  const [pets, setPets] = useState([]);
  useEffect(() => {
    setPets(insuredInfo[currentStep]?.petList || []); // Update local state
  }, [insuredInfo, currentStep]); // React will re-render when insuredInfo updates

  const getPetType = (petSpecies) => {
    if (petSpecies === 'CANINE'|| petSpecies === 'Canine') {
      return 'Dog';
    } else if (petSpecies === 'FELINE'|| petSpecies === 'Feline') {
      return 'Cat';
    }
    return '';
  };

  return (
    pets.length > 0 && (
      <div className="mt-4">
        <table className="table table-striped">
          <thead className="custom-thead">
            <tr>
              <th>PET NAME</th>
              <th>PET TYPE</th>
              <th>COVERAGE OPTION</th>
              <th>COST PER PAY PERIOD</th>
              {/* <th>APPLICATION STATUS</th> */}
            </tr>
          </thead>
          <tbody>
            {pets
              .filter(
                (pet) =>
                  pet.applicationStatus === 'Pending' ||
                  pet.applicationStatus === 'Enrolled' ||
                  pet.applicationStatus === ''
              )
              .map((pet, index) => (
                <tr key={index}>
                  <td>{pet.petName}</td>
                  <td>{getPetType(pet.petType)}</td>
                  <td>{pet.coverageLevel}</td>
                  <td>{pet.costPerPayPeriod}</td>
                  {/* <td>{pet.applicationStatus}</td> */}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    )
  );
};

export default PetAssureNationTable;
